// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1664":"4292ddaf","4536":"bfe1eda7"}[chunkId] + ".chunk.css";
};